import React from "react";
import { app, authentication } from "@microsoft/teams-js";

export const useAuth = () => {
  const [userName, setUserName] = React.useState("");
  const [isSignedIn, setIsSignedIn] = React.useState(false);
  const [isAuthenticating, setIsAuthenticating] = React.useState(true);
  const [authError, setAuthError] = React.useState<string | null>(null);
  const [accessToken, setAccessToken] = React.useState<string>("");
  const [userFullName, setUserFullName] = React.useState<string>("");

  React.useEffect(() => {
    console.log("Initializing authentication...");
    
    const initializeApp = async () => {
      try {
        // Try Teams SDK authentication
        try {
          await app.initialize();
          console.log("Teams SDK initialized");
          await app.getContext();
          const appIdUri = import.meta.env.VITE_APP_ID_URI;
          console.log("App ID URI:", appIdUri);
          const teamsToken = await authentication.getAuthToken({
            resources: [appIdUri],
            silent: false,
          });

          console.log("Token received:", teamsToken ? "Yes" : "No");
          console.log("Token (first 20 chars):", teamsToken.substring(0, 20) + "...");
         
          if (!teamsToken) {
            throw new Error("Failed to get authentication token");
          }


          setAccessToken(teamsToken);

          // Fetch user details from backend
          const backendBaseUrl = import.meta.env.VITE_API_ENDPOINT || "";
          console.log("Fetching user info from backend:", `${backendBaseUrl}/api/me`);
          const response = await fetch(`${backendBaseUrl}/api/me`, {
            headers: { Authorization: `Bearer ${teamsToken}` },
          });

          console.log("Backend response:", response);
          if (response.ok) {
            const userData = await response.json();
            console.log("User data fetched from backend:", userData);
            const displayName = userData?.user?.email || "";
            const fullName = userData?.user?.name || "";
            console.log("Full name extracted:", fullName);
            console.log("User object:", userData?.user);
            setUserFullName(fullName);
            setUserName(displayName);
            setIsSignedIn(true);
            console.log("✓ Authenticated via Teams SDK");
          } else {
            console.error("Backend authentication failed:", response.status);
            setAuthError(`Authentication failed: ${response.statusText || 'Unable to verify user'}`);
          }
          
          setIsAuthenticating(false);
          return;

        } catch (teamsError) {
          console.error("Teams authentication error:", teamsError);
          setAuthError("Failed to authenticate with Teams. Please try reopening the app.");
          setIsAuthenticating(false);
        }

      } catch (error) {
        console.error("Initialization error:", error);
        setAuthError("Something went wrong during authentication. Please try again.");
        setIsAuthenticating(false);
      }
    };

    initializeApp();
  }, []);

  const getAccessToken = async (): Promise<string> => {
    return accessToken;
  };

  return {
    userName,
    userFullName,
    isSignedIn,
    isAuthenticating,
    authError,
    getAccessToken,
  };
};